import type { Severity } from '../lib/types';

const STYLE: Record<Severity, { label: string; bg: string; fg: string }> = {
  high:     { label: 'HIGH',     bg: 'bg-danger/15',  fg: 'text-danger' },
  moderate: { label: 'MODERATE', bg: 'bg-warning/15', fg: 'text-warning' },
  healthy:  { label: 'HEALTHY',  bg: 'bg-success/15', fg: 'text-success' },
};

export function SeverityBadge({ severity }: { severity: Severity }) {
  const s = STYLE[severity];
  return (
    <span
      className={`px-2 py-0.5 rounded text-eyebrow tracking-widest ${s.bg} ${s.fg}`}
    >
      {s.label}
    </span>
  );
}
